import { flowChatTypes } from "modules/ai-agent/constants";
import AudioNode from "./audio-node";
import EndNode from "./end-node";
import QualificationNode from "./qualification-node";
import StartNode from "./start-node";
import TTSNode from "./tts-node";
import { NodeProps } from "@xyflow/react";
import SendMessageNode from "./send-message-node";
import LeadActionNode from "./lead-action-node";
import LLMNode from "./llm-node";

export const nodeTypes = {
  [flowChatTypes.START]: (props: NodeProps) => <StartNode {...props} />,
  [flowChatTypes.TTS]: (props: NodeProps) => <TTSNode {...props} />,
  [flowChatTypes.PLAY_AUDIO]: (props: NodeProps) => <AudioNode {...props} />,
  [flowChatTypes.QUESTION_CLASSIFIER]: (props: NodeProps) => <QualificationNode {...props} />,
  [flowChatTypes.FINISH]: (props: NodeProps) => <EndNode {...props} />,
  [flowChatTypes.SEND_MESSAGE]: (props: NodeProps) => <SendMessageNode {...props} />,
  [flowChatTypes.ACTION]: (props: NodeProps) => <LeadActionNode {...props} />,
  [flowChatTypes.LLM]: (props: NodeProps) => <LLMNode {...props} />,
};